
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class TheAbout extends Vue {
  @Prop({ default: true }) readonly isMobile!: boolean
  visibilityChanged(visible: boolean, entry: any) {
    if (visible) {
      entry.target.classList.add('show')
      entry.target.classList.remove('hidden')
    }
  }
}
